import React, { Component } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LoadingCircular from "../LoadingCircular";

class Enteghadat extends Component {
  state = {
    step: 1,
    isLoading: false,
    nameFamily: this.props.nameFamily,
    mobile: this.props.mobile,
    mokhatab: "",
    messageType: "",
    sharh: "",
  };
  onSubmit = async (e) => {
    e.preventDefault();
    if (this.state.mokhatab === "" || this.state.sharh === "") {
      alert("لطفا موارد ستاره دار را تکمیل نمایید");
      return;
    }
    //send to api
    const enteghad = {
      UserMobile: this.state.mobile,
      Dept: this.state.mokhatab,
      MessageType: null,
      Message: this.state.sharh,
    };
    this.setState({ isLoading: true });
    const res = await fetch("/ng/api/Criticisms", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(enteghad),
    });
    const dataBack = await res.json();
    this.setState({ isLoading: false });
    if (dataBack.Result === "Ok") {
      this.setState({ step: 2 });
    } else {
      alert("پاسخی از سرور دریافت نشد");
    }
  };
  render() {
    const { step, isLoading } = this.state;
    switch (step) {
      case 1:
        return (
          <Stack
            component="form"
            spacing={1.5}
            noValidate
            autoComplete="off"
            onSubmit={this.onSubmit}
          >
            <LoadingCircular open={isLoading} />
            <Typography variant="h6" sx={{ textAlign: "center" }}>
              انتقادات و پیشنهادات{" "}
            </Typography>
            <FormControl fullWidth sx={{ paddingTop: 3 }}>
              <InputLabel sx={{ paddingTop: 3 }} id="lbl1">
                واحد مربوطه *
              </InputLabel>
              <Select
                required
                //sx={{ mt: 4 }}
                labelId="lbl1"
                value={this.state.mokhatab}
                id="demo-simple-select"
                label="واحد مربوطه *"
                onChange={(e) => {
                  this.setState({ mokhatab: e.target.value });
                }}
              >
                <MenuItem value="مدیریت">مدیریت</MenuItem>
                <MenuItem value="واحد مالی">واحد مالی</MenuItem>
                <MenuItem value="واحد کنترل کیفیت">واحد کنترل کیفیت</MenuItem>
                <MenuItem value="بازرگانی و فروش">بازرگانی و فروش</MenuItem>
                <MenuItem value="سایر">سایر</MenuItem>
              </Select>
            </FormControl>
            <TextField
              required
              multiline
              label="شرح انتقاد/پیشنهاد"
              variant="standard"
              onChange={(e) => {
                this.setState({ sharh: e.target.value });
              }}
            />
            <Button type="submit" variant="contained">
              ثبت
            </Button>
          </Stack>
        );
      case 2:
        return (
          <Typography sx={{ textAlign: "center" }}>
            پیام شما با موفقیت ثبت شد، با تشکر از حسن توجه شما
          </Typography>
        );
      default:
    }
  }
}

export default Enteghadat;
